module.exports = __webpack_public_path__ + "images/nascc_registration_uplogo.1787648603550.png";